import { render, staticRenderFns } from "./DonatorManagement.vue?vue&type=template&id=2967f66f"
import script from "./DonatorManagement.vue?vue&type=script&lang=js"
export * from "./DonatorManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports